/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { ReferrerCodeIssuerLookup } from './partials/ReferrerCodeIssuerLookup';
import { BaseStepCompProps, IssuerListItem } from './types';

type SGXReferrerCodeIssuerLookupProps = Omit<BaseStepCompProps, 'handlePrevious'>;

export const SGXReferrerCodeIssuerLookup = (props: SGXReferrerCodeIssuerLookupProps) => {
  const { updateForm } = props;

  const handleSelectIssuer = (issuer?: IssuerListItem) => {
    updateForm('metadata', {
      sgx_issuer_name: issuer?.name,
    });
  }

  return <ReferrerCodeIssuerLookup
    {...props}
    handleSelectIssuer={handleSelectIssuer}
    description={(
      <>
        <p>If you don’t have a referral code, and you are
          a Singapore Listco, please access via SGXNet
          or <u><a href='mailto:support@g17.eco' className='text-ThemeHeadingLight'>get in touch</a></u>.</p>
        <p>If you can’t find your company on the list,
          then it might be because it’s not a Singapore Listco.
          If that is the case, then please see our products that
          are aimed at you:</p>
      </>
    )}
  />;
}
